import { render, staticRenderFns } from "./SentenceDictationType2Form.vue?vue&type=template&id=5ad2ee29&"
import script from "./SentenceDictationType2Form.vue?vue&type=script&lang=js&"
export * from "./SentenceDictationType2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports